// SwitchContext.js
import { createContext, useContext, useState } from "react";

export const SwitchContext = createContext();

export const SwitchProvider = ({ children }) => {
    const [switchValue, setSwitchValue] = useState(true);

    return (
        <SwitchContext.Provider value={{ switchValue, setSwitchValue }}>
            {children}
        </SwitchContext.Provider>
    );
};

export const useSwitch = () => useContext(SwitchContext);
